(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
/* Native overflow owns touch/trackpad scrolling. No wheel interception or body locks. */
if (!customElements.get('luxair-announcement')) {
  customElements.define('luxair-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.la-track');
      this.items = [...this.querySelectorAll('.la-item')];
      if (!this.track || !this.items.length) return;
      this.pause = this.querySelector('[data-pause]');
      this.counter = this.querySelector('.la-counter');
      this.progress = this.querySelector('.la-progress');
      this.panel = this.querySelector('.la-panel');
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[role=status]');
      this.querySelectorAll('[data-toggle],[data-dismiss],[data-close-panel],[data-copy]').forEach(button => { button.hidden = false; });
      if (this.panel) this.panel.hidden = true;
      this.media = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.touching = false;
      this.selected = false;
      this.visible = true;
      this.duration = Math.max(4000, Number(this.dataset.interval || 7) * 1000);
      this.storageKey = 'luxair-announcement:' + this.dataset.section;
      if (!window.Shopify?.designMode && this.dataset.dismissible === 'true') {
        try { this.hidden = sessionStorage.getItem(this.storageKey) === 'dismissed'; } catch (_) { /* Storage is optional. */ }
      }
      const listen = (node, type, fn) => node?.addEventListener(type, fn, { signal });
      listen(this.querySelector('[data-prev]'), 'click', () => this.go(-1, true));
      listen(this.querySelector('[data-next]'), 'click', () => this.go(1, true));
      listen(this.pause, 'click', () => { this.userPaused = !this.userPaused; this.sync(); });
      listen(this.toggle, 'click', () => this.setPanel(this.panel.hidden));
      listen(this.querySelector('[data-close-panel]'), 'click', () => { this.setPanel(false); this.toggle.focus(); });
      listen(this.querySelector('[data-dismiss]'), 'click', () => {
        this.hidden = true;
        this.sync();
        try { sessionStorage.setItem(this.storageKey, 'dismissed'); } catch (_) { /* Storage is optional. */ }
      });
      listen(this, 'keydown', event => {
        if (event.key === 'Escape' && this.panel && !this.panel.hidden) {
          this.setPanel(false); this.toggle.focus();
        }
        if (event.target === this.track && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.items.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
          this.to(next, true);
        }
      });
      listen(this, 'mouseenter', () => { if (this.dataset.hover !== 'false') { this.hovered = true; this.sync(); } });
      listen(this, 'mouseleave', () => { this.hovered = false; this.sync(); });
      listen(this, 'focusin', () => { this.focused = true; this.sync(); });
      listen(this, 'focusout', () => queueMicrotask(() => { if (this.isConnected) { this.focused = this.contains(document.activeElement); this.sync(); } }));
      listen(this.track, 'pointerdown', () => { this.touching = true; this.userPaused = true; this.sync(); });
      listen(window, 'pointerup', () => { if (this.touching) { this.touching = false; this.sync(); } });
      listen(window, 'pointercancel', () => { this.touching = false; this.sync(); });
      listen(this.track, 'wheel', () => { this.userPaused = true; this.sync(); });
      listen(this.track, 'scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.updateIndex(), 100);
      });
      listen(document, 'visibilitychange', () => this.sync());
      listen(this.media, 'change', () => this.layout());
      listen(this.motion, 'change', () => this.layout());
      listen(this, 'shopify:block:select', event => {
        const i = this.items.findIndex(item => item.dataset.block === event.detail.blockId);
        if (i >= 0) { this.selected = true; this.to(i, false, true); this.sync(); }
      });
      listen(this, 'shopify:block:deselect', () => { this.selected = false; this.sync(); });
      this.querySelectorAll('[data-copy]').forEach(button => listen(button, 'click', async () => {
        try {
          await navigator.clipboard.writeText(button.dataset.copy);
          this.status.textContent = 'Code ' + button.dataset.copy + ' copied.';
          button.textContent = 'Copied';
        } catch (_) {
          this.status.textContent = 'Select the code and copy it manually.';
          button.textContent = 'Select code to copy';
        }
      }));
      this.observer = new ResizeObserver(() => {
        const width = this.getBoundingClientRect().width;
        if (width !== this.lastWidth) { this.lastWidth = width; this.layout(); }
      });
      this.observer.observe(this);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); });
      this.intersection.observe(this);
      this.dataset.ready = '';
      this.layout();
      document.fonts?.ready.then(() => { if (this.isConnected && !signal.aborted) this.layout(); });
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.intersection?.disconnect();
      clearTimeout(this.timer); clearTimeout(this.scrollTimer); this.animation?.cancel();
    }
    layout() {
      if (!this.track) return;
      this.dataset.layout = 'carousel';
      if (!this.media.matches && this.dataset.mode === 'static') {
        this.dataset.layout = 'row';
        if (this.track.scrollWidth > this.track.clientWidth + 2) this.dataset.layout = 'carousel';
      }
      const carousel = this.dataset.layout === 'carousel' && this.items.length > 1;
      this.querySelector('.la-controls').hidden = !carousel;
      this.track.setAttribute('tabindex', carousel ? '0' : '-1');
      this.to(this.index, false, true);
      this.sync();
    }
    updateIndex() {
      if (this.dataset.layout === 'row') return;
      const left = this.track.getBoundingClientRect().left;
      let nearest = 0, distance = Infinity;
      this.items.forEach((item, i) => {
        const d = Math.abs(item.getBoundingClientRect().left - left);
        if (d < distance) { nearest = i; distance = d; }
      });
      this.index = nearest;
      this.counter.textContent = `${String(nearest + 1).padStart(2, '0')} / ${String(this.items.length).padStart(2, '0')}`;
      this.sync();
    }
    go(delta, manual) { this.to(this.index + delta, manual); }
    to(index, manual, instant = false) {
      // Wrapping should not animate past every intervening promotion.
      if (index < 0 || index >= this.items.length) instant = true;
      this.index = (index + this.items.length) % this.items.length;
      if (manual) this.userPaused = true;
      const item = this.items[this.index];
      const left = this.dataset.layout === 'row' ? 0 : this.track.scrollLeft + item.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
      this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.items.length).padStart(2, '0')}`;
      if (manual) this.status.textContent = `Announcement ${this.index + 1} of ${this.items.length}: ${item.querySelector('.la-heading')?.textContent.trim() || ''}`;
      this.sync();
    }
    setPanel(open) {
      if (!this.panel) return;
      this.panel.hidden = !open;
      this.toggle.setAttribute('aria-expanded', String(open));
      this.sync();
    }
    sync() {
      clearTimeout(this.timer); this.animation?.cancel();
      const enabled = (this.media.matches ? this.dataset.mobileAuto : this.dataset.auto) === 'true';
      const mayPlay = enabled && !this.motion.matches && this.items.length > 1 && this.dataset.layout === 'carousel';
      this.pause.hidden = !mayPlay;
      this.pause.setAttribute('aria-label', this.userPaused ? 'Play announcements' : 'Pause announcements');
      this.pause.setAttribute('aria-pressed', String(this.userPaused));
      this.pause.querySelector('[data-play-icon]').hidden = !this.userPaused;
      this.pause.querySelector('[data-pause-icon]').hidden = this.userPaused;
      const running = mayPlay && !this.userPaused && !this.hovered && !this.focused && !this.touching && !this.selected && !document.hidden && this.visible && !this.hidden && (!this.panel || this.panel.hidden) && !window.Shopify?.designMode;
      if (running) {
        this.animation = this.progress.animate([{ transform:'scaleX(0)' }, { transform:'scaleX(1)' }], {duration:this.duration,fill:'forwards'});
        this.timer = setTimeout(() => this.go(1, false), this.duration);
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
